const ACTION_TYPES = {
  SUBSCRIBE_PLAN: 'SUBSCRIBE_PLAN',
  UPGRADE_PLAN: 'UPGRADE_PLAN',
  HSPA_3G_SUNSET: 'HSPA_3G_SUNSET',
}

export default ACTION_TYPES
